import axios from "axios";
import React, { useEffect, useState } from "react";
import { set, useForm } from "react-hook-form";
import { useNavigate, useOutletContext } from "react-router-dom";
import $, { error } from "jquery";
import toastr from "../../../utils/toast";


function ReplaceContact({ company_id, role_id, onClose }) {
const { register, handleSubmit, watch, setValue, formState:{ errors } } = useForm();
const navigate = useNavigate();
const { setGlobalLoading, token } = useOutletContext();
const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const CURRENCY_API_KEY = process.env.REACT_APP_CURRENCY_API_KEY;
const [contacts, setContacts] = useState([]);
const [contactMode, setContactMode] = useState("existing"); 

  useEffect(() => {
    const getContactDetails = async () => {
      try {
     //   setGlobalLoading(true);
        const response = await axios.get(
          `${REACT_APP_API_BASE_URL}/orders/get_contact_list/${company_id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setContacts(response.data.contact_list || []);
        setValue("role_id",role_id);
        setValue("company_id",company_id);
       
      } catch (error) {
        console.log(error);
        setGlobalLoading(false);
      } finally {
        setGlobalLoading(false);
      }
    };
    getContactDetails();
  }, [company_id]);

  const onSubmit = async (data) => {
    try {
      setGlobalLoading(true);
      const formData = new FormData();
      Object.entries(data).forEach(([key, value]) => {
        formData.append(key, value ?? "");
      });

      const response = await axios.post(
        `${API_BASE_URL}/orders/add_new_contact`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
    //  console.log(response);
      toastr.success("Contact update successfully!");
      onClose();
    } catch (err) {
      console.error("Submission failed:", err);
      alert("Error updating User.");
    } finally {
      setGlobalLoading(false);
    }
  }; 

return (
    <div className="modal fade show d-block" tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered modal-md" role="document" style={{ maxWidth: "550px" }}>
        <div className="modal-content">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-header">
              <h4 className="modal-title">Add New Contact</h4>
                <input type="hidden" {...register("company_id")} />
                <input type="hidden" {...register("role_id")} />
              <button onClick={() => onClose()} type="button" className="btn-close custom-btn-close" data-bs-dismiss="modal" aria-label="Close">
                <i className="ti ti-x"></i>
              </button>
            </div>

            <div className="modal-body row" style={{ textAlign: "left" }}>
              <div className="mb-3 d-flex gap-4">
                <label>
                  <input type="radio" value="existing" checked={contactMode === "existing"} onChange={(e) => setContactMode(e.target.value)} />{" "} Existing
                </label>

                <label>
                  <input type="radio" value="new" checked={contactMode === "new"} onChange={(e) => setContactMode(e.target.value)}/>{" "} New
                </label>
              </div>
              {contactMode === "existing" && (
                <div className="mb-3">
                    <label className="form-label">Select Contact *</label>
                    <select className="form-control" {...register("existing_contact_id", { required: true })}>
                        <option value="">-- Select Contact --</option>
                        {contacts.map((c) => (
                        <option key={c.id} value={c.id}>
                            {c.name} ({c.designation})
                        </option>
                        ))}
                    </select>
                </div>
                )}
              {contactMode === "new" && (
                <div className="row">
                    <div className="col-md-6 col-sm-6">
                        <div className="mb-2">
                        <label className="form-label">First Name *</label>
                        <input type="text" {...register("firstname", { required: true })} className={`form-control ${ errors.firstname && "is-invalid"}`}/>
                        </div>

                        <div className="mb-2">
                        <label className="form-label">Phone *</label>
                        <input type="text" {...register("phone", { required: true })} className={`form-control ${ errors.phone && "is-invalid"}`} />
                        </div>

                        <div className="mb-2">
                        <label className="form-label">Designation *</label>
                        <input type="text" {...register("designation", { required: true })} className={`form-control ${ errors.designation && "is-invalid"}`} />
                        </div>
                    </div>

                    <div className="col-md-6 col-sm-6">
                        <div className="mb-2">
                        <label className="form-label">Last Name *</label>
                        <input type="text" {...register("lastname", { required: true })} className={`form-control ${ errors.lastname && "is-invalid"}`} />
                        </div>

                        <div className="mb-2">
                        <label className="form-label">Email *</label>
                        <input type="text" {...register("email")} className={`form-control ${ errors.email && "is-invalid"}`} />
                        </div>
                    </div>
                    <div className="col-md-12 col-sm-12">
                        <div className="mb-2">
                            <label className="form-label">Address *</label>
                            <input type="text" {...register("address")} className={`form-control ${ errors.address && "is-invalid"}`} />
                        </div>
                    </div>
                </div>
                )}
            </div>
            <div className="modal-footer">
              <button onClick={onClose} type="button" className="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close">
                Close
              </button>
              <button type="submit" className="btn btn-primary ms-2">
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>  
);    
}
export default ReplaceContact;